var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7556 10.6974C29.3567 9.09628 29.3568 6.50031 27.7556 4.89916C26.1545 3.29801 23.5585 3.29799 21.9573 4.89914L5.09988 21.7566C3.49873 23.3577 3.49875 25.9537 5.0999 27.5549C6.70105 29.156 9.29701 29.156 10.8982 27.5548L27.7556 10.6974Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7997 5.10196L5.04128 21.8604C4.23487 21.054 3.78181 19.9603 3.78181 18.8198C3.78181 17.6794 4.23483 16.5857 5.04123 15.7793L15.6478 5.17266C16.0436 4.75803 16.5183 4.42675 17.044 4.19823C17.5697 3.9697 18.1357 3.84856 18.7089 3.84198C19.2821 3.83539 19.8507 3.94346 20.3815 4.15984C20.9123 4.37622 21.3945 4.69654 21.7997 5.10196Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9546 27.6806L27.713 10.9222C28.5194 11.7286 28.9725 12.8224 28.9725 13.9628C28.9725 15.1032 28.5194 16.1969 27.713 17.0033L17.1064 27.6099C16.3 28.4163 15.2063 28.8694 14.0659 28.8694C12.9254 28.8694 11.8317 28.4163 11.0253 27.6099L10.9546 27.6806Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82715 23.614C9.82715 21.614 11.2272 23.014 13.2272 21.114C15.2272 19.214 13.7272 17.714 15.7272 15.714C17.7272 13.714 19.1272 15.114 21.1272 13.214C23.1272 11.314 21.6272 9.81396 23.6272 7.81396",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotDog);
export default __webpack_public_path__ + "static/media/hot_dog.11f6aedcbf44728df41121afb69e8fdc.svg";
export { ForwardRef as ReactComponent };